import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import { Message, Segment, Button, Form } from 'semantic-ui-react'
import 'moment-timezone'
import {registerAction} from '../../../../actions/registration.action'

const { Field } = Form

class Register extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      hasError: false,
      error: undefined,
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      location: ''
    }
  }

  handleSubmit (e) {
    e.preventDefault()
    this.setState({
      isLoading: true
    })
    const form = {
      email: this.state.email,
      password: this.state.password,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      location: this.state.location
    }
    this.props.registerAction(form,
      (error) => {
        this.setState({
          hasError: true,
          password: '',
          error: error,
          isLoading: false
        })
      })
  }
  onChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  render () {
    const {hasError, error} = this.state
    let errorNode

    if (hasError) {
      errorNode = <Message negative>{error.message}</Message>
    }

    return (
      <Segment>
        <Form loading={this.state.isLoading} onSubmit={this.handleSubmit.bind(this)}>
          <h2>Register</h2>
          {errorNode}
          <Field>
            <label htmlFor='email'>Email</label>
            <input autoFocus type='email' name='email' id='email' value={this.state.email} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='password'>Password</label>
            <input type='password' name='password' id='password' value={this.state.password} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='first_name'>First name</label>
            <input name='first_name' id='first_name' value={this.state.first_name} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='last_name'>Last name</label>
            <input name='last_name' id='last_name' value={this.state.last_name} onChange={this.onChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='location'>Company name</label>
            <input name='location' id='location' value={this.state.location} onChange={this.onChange.bind(this)} required />
          </Field>

          <Button primary type='submit'>Register</Button>
        </Form>
      </Segment>
    )
  }
}

Register.propTypes = {
  register: PropTypes.func
}

function mapStateToProps (state) {
  return state.registration
}

export default connect(mapStateToProps, {registerAction})(Register)



// WEBPACK FOOTER //
// ./src/pages/auth/components/register/index.js